import { Button, CheckboxCard, CheckboxWrapper } from '@design-system';
import { useTranslation } from 'next-i18next';

import { useFlow } from '../../../../providers';
import { GeneratedAddress } from '../../../../types/generated';
import { useAnalyticsEmitter } from '../../../../utils/analytics/emitter';
import { CardButton } from '../CardButton';

interface Props {
  addresses: GeneratedAddress[];
  selectedAddressId?: string;
  onUpdate: (addressId: string) => Promise<void>;
  setSelectedAddressId: (addressId: string) => void;
}

export const ShippingAddressSelector = ({
  addresses,
  onUpdate,
  selectedAddressId,
  setSelectedAddressId,
}: Props) => {
  const { t } = useTranslation(['product', 'countries']);
  const { goToStep } = useFlow();

  const [emitter] = useAnalyticsEmitter();

  return (
    <div className="flex flex-col">
      <div className="mb-8 flex flex-col gap-3">
        <CheckboxWrapper>
          {addresses.map((address) => (
            <CheckboxCard
              checked={selectedAddressId === address.id}
              id={address.id}
              label={`${address.firstName} ${address.lastName}`}
              name="address"
              onChange={() => setSelectedAddressId(address.id)}
              slot={
                <div className="flex w-full flex-col">
                  <p className="text-neutral-4">
                    {[address.addressLine1, address.addressLine2]
                      .filter(Boolean)
                      .join(', ')}
                  </p>
                  <p className="text-neutral-4">
                    {address.zip?.toLocaleUpperCase()} {address.city},{' '}
                    {address.countryName}
                  </p>
                </div>
              }
              type="radio"
              value={address.id}
            />
          ))}
        </CheckboxWrapper>

        <CardButton
          icon="chevron"
          onClick={() => {
            emitter('add new', 'clicked');
            goToStep('add_shipping_address');
          }}
        >
          {t('drawers.shipping.addNewButton')}
        </CardButton>
      </div>
      <Button
        disabled={!selectedAddressId}
        fullWidth
        label={t('drawers.shipping.saveButton')}
        onClick={() => {
          if (!selectedAddressId) return;
          onUpdate(selectedAddressId);
          emitter('existing', 'selected');
          goToStep('review');
        }}
        variant="primary"
      />
    </div>
  );
};
